export default __webpack_public_path__ + "static/rovo-overlay-remix-light-834ff6a425932a6e6f64a96e266491e5cd3a7564ef21a27369a9968d49cc502f.png";